const StreetAddress = ({
    street = '',
    state = '',
    city = '',
    zip = '',
    unit = '',
    country = '',
    show = '',
    hasUnitLabel = '',
} = {}) => ({
    street: String(street),
    state: String(state),
    city: String(city),
    zip: String(zip),
    unit: String(unit),
    country: String(country),
    show: Boolean(show),
    hasUnitLabel: Boolean(hasUnitLabel),
});

export default StreetAddress;
